import { Stack, Typography, Divider } from '@mui/material'
import { upperFirst } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { CurrencyKind } from 'src/api/types/units'
import { useCurrencyFormatter } from 'src/layout/AgencySettings'

interface IProps {
  prorations: { [key: string]: number }
  total_amount: number
}

export const useTotalAmountDisplay = function (totalAmount: number) {
  const { t } = useTranslation()
  const currencyFormatter = useCurrencyFormatter(CurrencyKind.Global)

  const totalText = `${upperFirst(t('total'))}:`
  const formattedAmount = currencyFormatter(totalAmount.toFixed(2))

  return [totalText, formattedAmount]
}

export const getMinWidth = function (totalText: string, formattedAmount: string) {
  return totalText.length + 1 + formattedAmount.length // +1 for the space in-between
}

export const ProrationsColumn = function (props: IProps) {
  const currencyFormatter = useCurrencyFormatter(CurrencyKind.Global)
  const prorations = Object.entries(props.prorations)

  const [totalText, formattedAmount] = useTotalAmountDisplay(props.total_amount)
  const minWidth = getMinWidth(totalText, formattedAmount)

  return (
    <Stack gap={2} divider={<Divider />}>
      {prorations.length && (
        <Stack gap={1}>
          {prorations.map(([zone, amount]) => (
            <Stack justifyContent="start" direction={'row'} gap={3} key={zone}>
              <Typography>{zone}:</Typography>
              <Typography>{currencyFormatter(amount.toFixed(2))}</Typography>
            </Stack>
          ))}
        </Stack>
      )}
      <Stack justifyContent="start" gap={3} direction={'row'} minWidth={`${minWidth}em`}>
        <Typography fontWeight={'bold'}>{totalText}</Typography>
        <Typography fontWeight={'bold'}>{formattedAmount}</Typography>
      </Stack>
    </Stack>
  )
}
